var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDomain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 367.38,
    height: 166.575,
    viewBox: "0 0 367.38 166.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "figure-4",
    transform: "translate(-306.219 -193.365)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_396",
    "data-name": "Line 396",
    x2: 367.38,
    transform: "translate(306.219 359.148)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21888",
    "data-name": "Group 21888",
    transform: "translate(332.538 193.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21870",
    "data-name": "Group 21870",
    transform: "translate(267.975 107.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44444",
    "data-name": "Path 44444",
    d: "M586.929,342.127H568.956l-2.272-21.36H589.2Z",
    transform: "translate(-565.359 -284.657)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9649",
    "data-name": "Rectangle 9649",
    width: 25.167,
    height: 3.408,
    rx: 0.361,
    transform: "translate(0 32.702)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21866",
    "data-name": "Group 21866",
    transform: "translate(9.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44445",
    "data-name": "Path 44445",
    d: "M576.3,290.707c3.972,10.316-6.535,20.63-.822,30.946h3.02c-5.715-10.316,4.793-20.63.822-30.946C578.245,288.365,575.555,288.365,576.3,290.707Z",
    transform: "translate(-573.737 -288.951)",
    fill: "#f2f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44446",
    "data-name": "Path 44446",
    d: "M576.3,290.707c3.972,10.316-6.535,20.63-.822,30.946h3.02c-5.715-10.316,4.793-20.63.822-30.946C578.245,288.365,575.555,288.365,576.3,290.707Z",
    transform: "translate(-573.737 -288.951)",
    fill: "none",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21867",
    "data-name": "Group 21867",
    transform: "translate(16.124 2.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44447",
    "data-name": "Path 44447",
    d: "M585.792,297.458c-2.1,2.1-6.015,1.6-6.015,1.6s-.506-3.913,1.6-6.015,6.015-1.6,6.015-1.6S587.894,295.356,585.792,297.458Z",
    transform: "translate(-579.723 -291.389)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    y1: 5.32,
    x2: 5.32,
    transform: "translate(0.053 2.344)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21868",
    "data-name": "Group 21868",
    transform: "translate(12.584 19.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44448",
    "data-name": "Path 44448",
    d: "M582.673,312.245c-2.1,2.1-6.015,1.6-6.015,1.6s-.506-3.915,1.6-6.015,6.015-1.6,6.015-1.6S584.774,310.144,582.673,312.245Z",
    transform: "translate(-576.604 -306.176)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_398",
    "data-name": "Line 398",
    y1: 5.32,
    x2: 5.32,
    transform: "translate(0.053 2.345)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21869",
    "data-name": "Group 21869",
    transform: "translate(2.708 10.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44449",
    "data-name": "Path 44449",
    d: "M569.551,304.211c2.1,2.1,6.015,1.6,6.015,1.6s.506-3.913-1.6-6.015-6.015-1.6-6.015-1.6S567.449,302.109,569.551,304.211Z",
    transform: "translate(-567.902 -298.142)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_399",
    "data-name": "Line 399",
    x1: 5.32,
    y1: 5.32,
    transform: "translate(2.345 2.345)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9650",
    "data-name": "Rectangle 9650",
    d: "M4,0H163.035a4,4,0,0,1,4,4V24.654a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(88.078 38.907)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9651",
    "data-name": "Rectangle 9651",
    width: 167.035,
    height: 101.708,
    transform: "translate(88.078 63.56)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9652",
    "data-name": "Rectangle 9652",
    width: 37.134,
    height: 4.786,
    rx: 2.108,
    transform: "translate(98.482 49.543)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21871",
    "data-name": "Group 21871",
    transform: "translate(103.98 93.607)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9653",
    "data-name": "Rectangle 9653",
    width: 40.835,
    height: 41.615,
    rx: 0.539,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9654",
    "data-name": "Rectangle 9654",
    width: 16.841,
    height: 5.422,
    rx: 2.389,
    transform: "translate(53.254 35.308)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9655",
    "data-name": "Rectangle 9655",
    width: 83.52,
    height: 10.845,
    rx: 0.539,
    transform: "translate(54.07 0.104)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9656",
    "data-name": "Rectangle 9656",
    width: 57.19,
    height: 10.845,
    rx: 0.539,
    transform: "translate(54.07 17.452)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21874",
    "data-name": "Group 21874",
    transform: "translate(296.179 132.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21872",
    "data-name": "Group 21872",
    transform: "translate(10.845 5.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44450",
    "data-name": "Path 44450",
    d: "M605.991,321.149c-2.1,2.1-6.015,1.6-6.015,1.6s-.505-3.913,1.6-6.015,6.015-1.6,6.015-1.6S608.093,319.047,605.991,321.149Z",
    transform: "translate(-599.922 -315.08)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_400",
    "data-name": "Line 400",
    y1: 5.32,
    x2: 5.32,
    transform: "translate(0.054 2.345)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21873",
    "data-name": "Group 21873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44451",
    "data-name": "Path 44451",
    d: "M596.436,312.213c2.1,2.1,1.6,6.015,1.6,6.015s-3.913.506-6.015-1.6-1.6-6.015-1.6-6.015S594.335,310.112,596.436,312.213Z",
    transform: "translate(-590.367 -310.564)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_401",
    "data-name": "Line 401",
    x1: 5.32,
    y1: 5.32,
    transform: "translate(2.345 2.345)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9657",
    "data-name": "Rectangle 9657",
    d: "M0,0H15.242a0,0,0,0,1,0,0V8.066A6.193,6.193,0,0,1,9.05,14.259H6.193A6.193,6.193,0,0,1,0,8.066V0A0,0,0,0,1,0,0Z",
    transform: "translate(1.466 18.577)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9658",
    "data-name": "Rectangle 9658",
    d: "M.732,0H14.51a.732.732,0,0,1,.732.732V3.008a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.732A.732.732,0,0,1,.732,0Z",
    transform: "translate(1.466 15.608)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9659",
    "data-name": "Rectangle 9659",
    d: "M1.021,0H1.3A1.021,1.021,0,0,1,2.317,1.021V14.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.021A1.021,1.021,0,0,1,1.021,0Z",
    transform: "translate(7.929 1.166)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21877",
    "data-name": "Group 21877",
    transform: "translate(0 132.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21875",
    "data-name": "Group 21875",
    transform: "translate(10.845 5.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44452",
    "data-name": "Path 44452",
    d: "M345.032,321.149c-2.1,2.1-6.015,1.6-6.015,1.6s-.506-3.913,1.6-6.015,6.015-1.6,6.015-1.6S347.134,319.047,345.032,321.149Z",
    transform: "translate(-338.963 -315.08)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_402",
    "data-name": "Line 402",
    y1: 5.32,
    x2: 5.32,
    transform: "translate(0.053 2.345)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21876",
    "data-name": "Group 21876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44453",
    "data-name": "Path 44453",
    d: "M335.477,312.213c2.1,2.1,1.6,6.015,1.6,6.015s-3.913.506-6.015-1.6-1.6-6.015-1.6-6.015S333.375,310.112,335.477,312.213Z",
    transform: "translate(-329.408 -310.564)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_403",
    "data-name": "Line 403",
    x1: 5.32,
    y1: 5.32,
    transform: "translate(2.345 2.345)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9660",
    "data-name": "Rectangle 9660",
    d: "M0,0H15.242a0,0,0,0,1,0,0V8.066A6.193,6.193,0,0,1,9.05,14.259H6.193A6.193,6.193,0,0,1,0,8.066V0A0,0,0,0,1,0,0Z",
    transform: "translate(1.466 18.577)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9661",
    "data-name": "Rectangle 9661",
    d: "M.732,0H14.51a.732.732,0,0,1,.732.732V3.008a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V.732A.732.732,0,0,1,.732,0Z",
    transform: "translate(1.466 15.608)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9662",
    "data-name": "Rectangle 9662",
    d: "M1.021,0H1.3A1.021,1.021,0,0,1,2.317,1.021V14.442a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V1.021A1.021,1.021,0,0,1,1.021,0Z",
    transform: "translate(7.929 1.166)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_44454",
    "data-name": "Path 44454",
    d: "M368.183,298.76c-3.683-4.614-12.045-16.492-11.266-32.292.222-4.5.622-20.526,10.529-26.11,5.886-3.318,12.4-3.12,16.378,2.733,3.726,5.49,1.474,11.541-2.77,15.222-6.958,6.035-18.81,3.4-25.564-3.883-8.277-8.921-6.226-22.646-4.813-28.039,5.238-19.991,23.451-28.736,25.01-29.455,17.275-7.955,36.017.9,49.509,11.859,25.916,21.056,47.808-12.806,78.7,6.46",
    transform: "translate(-326.714 -193.879)",
    fill: "none",
    stroke: "#b2b9c3",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21880",
    "data-name": "Group 21880",
    transform: "translate(162.336 26.514)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9663",
    "data-name": "Rectangle 9663",
    width: 114.568,
    height: 23.562,
    rx: 2.608,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21878",
    "data-name": "Group 21878",
    transform: "translate(96.365 7.041)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976",
    "data-name": "Ellipse 976",
    cx: 3.876,
    cy: 3.876,
    r: 3.876,
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_404",
    "data-name": "Line 404",
    x2: 3.09,
    y2: 3.09,
    transform: "translate(6.617 6.617)",
    fill: "#fff",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21879",
    "data-name": "Group 21879",
    transform: "translate(9.943 8.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44455",
    "data-name": "Path 44455",
    d: "M483.076,231.419l-1.876-6.79h1.707l1.121,4.379,1.355-4.379h1.5l1.343,4.392,1.121-4.392h1.667l-1.876,6.79h-1.721l-1.3-4.34-1.317,4.34Z",
    transform: "translate(-481.2 -224.629)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44456",
    "data-name": "Path 44456",
    d: "M492.057,231.419l-1.876-6.79h1.707l1.121,4.379,1.355-4.379h1.5l1.343,4.392,1.121-4.392H500l-1.876,6.79H496.4l-1.3-4.34-1.317,4.34Z",
    transform: "translate(-479.988 -224.629)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44457",
    "data-name": "Path 44457",
    d: "M501.039,231.419l-1.877-6.79h1.707l1.121,4.379,1.355-4.379h1.5l1.343,4.392,1.121-4.392h1.668l-1.877,6.79h-1.721l-1.3-4.34-1.317,4.34Z",
    transform: "translate(-478.776 -224.629)",
    fill: "#b2b9c3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21887",
    "data-name": "Group 21887",
    transform: "translate(31.932 108.483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21882",
    "data-name": "Group 21882"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9664",
    "data-name": "Rectangle 9664",
    width: 60.815,
    height: 18.935,
    rx: 2.569,
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44458",
    "data-name": "Path 44458",
    d: "M377.212,302.352H366.04a4.345,4.345,0,0,0-3.843,2.318l-1.049,1.988h20.957l-1.049-1.988A4.346,4.346,0,0,0,377.212,302.352Z",
    transform: "translate(-357.056 -287.723)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_405",
    "data-name": "Line 405",
    x1: 22.187,
    transform: "translate(38.628 9.468)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977",
    "data-name": "Ellipse 977",
    cx: 4.605,
    cy: 4.605,
    r: 4.605,
    transform: "translate(33.58 4.862)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21881",
    "data-name": "Group 21881",
    transform: "translate(6.662 5.536)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978",
    "data-name": "Ellipse 978",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979",
    "data-name": "Ellipse 979",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    transform: "translate(6.169)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980",
    "data-name": "Ellipse 980",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    transform: "translate(12.339)",
    fill: "#b2b9c3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21884",
    "data-name": "Group 21884",
    transform: "translate(0 18.935)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9665",
    "data-name": "Rectangle 9665",
    width: 60.815,
    height: 18.935,
    rx: 2.569,
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44459",
    "data-name": "Path 44459",
    d: "M377.212,319.035H366.04a4.345,4.345,0,0,0-3.843,2.318l-1.049,1.988h20.957l-1.049-1.988A4.346,4.346,0,0,0,377.212,319.035Z",
    transform: "translate(-357.056 -304.406)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_406",
    "data-name": "Line 406",
    x1: 22.187,
    transform: "translate(38.628 9.468)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981",
    "data-name": "Ellipse 981",
    cx: 4.605,
    cy: 4.605,
    r: 4.605,
    transform: "translate(33.58 4.862)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21883",
    "data-name": "Group 21883",
    transform: "translate(6.662 5.536)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982",
    "data-name": "Ellipse 982",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983",
    "data-name": "Ellipse 983",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    transform: "translate(6.169)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_984",
    "data-name": "Ellipse 984",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    transform: "translate(12.339)",
    fill: "#b2b9c3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21886",
    "data-name": "Group 21886",
    transform: "translate(0 37.87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9666",
    "data-name": "Rectangle 9666",
    width: 60.815,
    height: 18.935,
    rx: 2.569,
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44460",
    "data-name": "Path 44460",
    d: "M377.212,335.719H366.04a4.345,4.345,0,0,0-3.843,2.318l-1.049,1.988h20.957l-1.049-1.988A4.346,4.346,0,0,0,377.212,335.719Z",
    transform: "translate(-357.056 -321.09)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_407",
    "data-name": "Line 407",
    x1: 22.187,
    transform: "translate(38.628 9.468)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_985",
    "data-name": "Ellipse 985",
    cx: 4.605,
    cy: 4.605,
    r: 4.605,
    transform: "translate(33.58 4.862)",
    fill: "#f2f6f9",
    stroke: "#b2b9c3",
    strokeWidth: 1.375
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21885",
    "data-name": "Group 21885",
    transform: "translate(6.662 5.536)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_986",
    "data-name": "Ellipse 986",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_987",
    "data-name": "Ellipse 987",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    transform: "translate(6.169)",
    fill: "#b2b9c3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_988",
    "data-name": "Ellipse 988",
    cx: 1.738,
    cy: 1.738,
    r: 1.738,
    transform: "translate(12.339)",
    fill: "#b2b9c3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDomain);
export default __webpack_public_path__ + "static/media/empty-domain.f4e86abdc60ea5b4dbc9dce0abdd1e4a.svg";
export { ForwardRef as ReactComponent };